import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUserMd } from "@fortawesome/free-solid-svg-icons";
import api from "../services/api";
import Swal from "sweetalert2";

export default function AttendanceStatusModal({ show, onHide, attendance, onStatusChange }) {
  const [selectedStatus, setSelectedStatus] = useState(attendance?.budget_status || '0');
  const [isLoading, setIsLoading] = useState(false);

  const statusOptions = [
    // { value: '0', text: 'Em aberto', colorClass: 'delivering', description: 'Atendimento ainda não processado' },
    // { value: '1', text: 'Orçamento enviado', colorClass: 'bg-info', description: 'Orçamento foi enviado ao cliente' },
    { value: '2', text: 'Vendido', colorClass: 'bg-success', description: 'Cliente aceitou o orçamento' },
    { value: '3', text: 'Negado', colorClass: 'bg-danger', description: 'Cliente recusou o orçamento' }
  ];

  const getStatusInfo = (status) => {
    return statusOptions.find(option => option.value === status) ||
      { text: 'Desconhecido', colorClass: 'bg-secondary', description: 'Status não identificado' };
  };

  const handleSave = async () => {
    setIsLoading(true);

    await api.put('api/attendances/update/budgetStatus', {
      attendance_id: attendance.attendance_id,
      budget_status: selectedStatus 
    })
    .then(response => {
      Swal.fire({
        icon: 'success',
        title: 'Status atualizado',
        text: 'O status do atendimento foi atualizado com sucesso.',
        timer: 2000,
        showConfirmButton: false,
        position: 'top',
        toast: true
      })
    
       // Chamar callback para atualizar o componente pai
       if (onStatusChange) {
        onStatusChange(attendance.attendance_id, selectedStatus);
      }

      onHide();
    })
    .catch(error => {
      console.error('Erro ao atualizar status:', error);
    })
    .finally(() => {
      setIsLoading(false);
    })

  };

  if (!attendance) return null;

  const currentStatus = getStatusInfo(attendance.budget_status);

  return (
    <Modal show={show} onHide={onHide} size="md">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="d-flex align-items-center gap-2">
          Alterar Status do Atendimento
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        <div className="bg-light rounded p-3 mb-4">
          <div className="d-flex align-items-center gap-2 mb-2">
            <FontAwesomeIcon icon={faUser} className="text-primary" />
            <div className="ms-4 text-muted">Paciente: <strong>{attendance.name}</strong></div>
          </div>

          <div className="d-flex align-items-center gap-2 mb-2">
            <FontAwesomeIcon icon={faUserMd} className="text-primary" />
            <div className="ms-4 text-muted">Profissional: <strong>{attendance.professional_name}</strong></div>
          </div>
        </div>

        <div className="mb-4">
          <label className="form-label fw-semibold">Status Atual:</label>
          <div className="d-flex align-items-center gap-3">
            <span className={`status-info text-white ${currentStatus.colorClass}`}>
              {currentStatus.text.toLowerCase()}
            </span>
            <small className="text-muted">{currentStatus.description}</small>
          </div>
        </div>

        <div>
          <label className="form-label fw-semibold">Novo Status:</label>
          <div className="mb-3">
            {statusOptions.map(option => (
              <Form.Check
                key={option.value}
                type="radio"
                id={`status-${option.value}`}
                name="status"
                value={option.value}
                label={option.text}
                checked={selectedStatus === option.value}
                onChange={(e) => setSelectedStatus(e.target.value)}
                className="mb-2"
                disabled={option.value === attendance.budget_status}
              />
            ))}
          </div>
          <div className="bg-light rounded p-3">
            <div className="d-flex align-items-center gap-3 mb-2">
              <span className={`status-info text-white ${getStatusInfo(selectedStatus).colorClass}`}>
                {getStatusInfo(selectedStatus).text.toLowerCase()}
              </span>
            </div>
            <small className="text-muted">
              {getStatusInfo(selectedStatus).description}
            </small>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="bg-light">
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={isLoading}
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={isLoading || selectedStatus === attendance.budget_status}
        >
          {isLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Salvando...
            </>
          ) : (
            'Atualizar status'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}